<template>
    <div class="form-container">

        <div role="alert" class="container alert status-box alert-danger" style="" v-show="error.length">
            <button type="button" aria-label="Close" class="close" @click="error = ''">
                <span aria-hidden="true">×</span>
            </button>
            <div class="row">
                <div class="col media">
                    <div class="d-flex mr-2 status-icon">
                        <i class="fa fa-remove"></i>
                    </div>
                    <div class="media-body">
                        {{ error }}
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-4">Name</div>
            <div class="col-8">
                <input
                        ref="name"
                        type="text"
                        class="form-control"
                        v-model="form.name"
                /> </div>
        </div>

        <div class="row">
            <div class="col-4">Team Lead</div>
            <div class="col-8">
                <auto-complete
                    :list="teamAgentNames"
                    :selection="form.source_agent.user_name"
                    @input="getSourceAgents"
                    @change="setAgent" >
                </auto-complete>

            </div>
        </div>

        <div class="row">
            <div class="col-4">
                <br />
                Addresses

            </div>
            <div class="col-8">
                <a class="toggle-link text-right" @click.prevent="setAddMultipleAddresses" v-show="!addMultipleAddresses">Paste Multiple Addresses at once</a>
                <a class="toggle-link text-right" @click.prevent="setAddMultipleAddresses" v-show="addMultipleAddresses">Add Addresses one-by-one</a>
                <span v-show="!addMultipleAddresses">
                    <google-address-searcher @input="addAddress" :selected="address"  ></google-address-searcher>
                    <div class="btn btn-download" style="margin: 5px;"  v-for="d, i in form.data_locations">
                        <div>{{ d.formatted_address }}  &nbsp;&nbsp;<i class="fa fa-remove" @click="form.data_locations.splice(i,1);"></i></div>
                    </div>
                </span>

                <span v-show="addMultipleAddresses">
                    <google-multiple-address-searcher @input="addAddresses" v-model="entered_addresses"></google-multiple-address-searcher>
                </span>
            </div>


        </div>

        <div class="row">
            <div class="col-4">Notes</div>
            <div class="col-8">
                <textarea class="form-control" v-model="form.notes" rows="4"></textarea>
            </div>
        </div>



        <div class="modal-footer">

            <button class="btn btn-clear" @click="$emit('close');" >Cancel</button>
            <button @click="saveLead" class="btn btn-primary">Save New Lead</button>
            <loading v-show="isLoading" style="float:right;" :isLoading="loading" color="#5e9cd3"> </loading>
        </div>

    </div>

</template>
<script type="text/babel">
    import Loading from 'vue-spinner/src/PulseLoader.vue';
    import Datepicker from 'vuejs-datepicker';
    import AutoComplete  from '../assets/Autocomplete.vue';
    import Dropdown from '../assets/Dropdown.vue';
    import GoogleAddressSearcher from '../assets/GoogleAddressSearcher.vue';
    import GoogleMultipleAddressSearcher from '../assets/GoogleMultipleAddressSearcher.vue';

    export default {

        data: function(){
            return {
                form:{
                    name: '',
                    source_agent: {
                        leadTeam_id : "",
                        user_id : "",
                        user_name : ""
                    },
                    data_locations: []

                },
                entered_addresses: '',
                leadTeamAgents: [],
                address: '',
                addMultipleAddresses: false,
                error: "",
                isLoading: false,
            }
        },
        beforeCreate(){

        },
        components:{
            Dropdown,
            Loading,
            AutoComplete,
            Datepicker,
            GoogleAddressSearcher,
            GoogleMultipleAddressSearcher
        },
        created(){

            if(this.selected){
                this.form.name = this.selected.name || null;
            }

        },
        computed:{
            teamAgentNames() {
                return this.leadTeamAgents.map(l => l.user_name);
            }

        },
        filters:{

        },

        methods:{
            addAddresses(addresses){
                this.form.data_locations = addresses;
            },
            setAddMultipleAddresses(){

              this.form.data_locations = [];
              this.addMultipleAddresses = !this.addMultipleAddresses;

            },
            addAddress(address){

                if(address.formatted_address){
                    this.form.data_locations.push(address);
                    this.address = {
                        address: '',
                        city: '',
                        state: '',
                        zip: '',
                        lat:'',
                        lng:'',
                        neighborhood: '',
                        formatted_address: ''
                    };
                }
            },
            setAgent(name){

                var su = this.leadTeamAgents.filter(l => l.user_name == name );

                this.form.source_agent = su.length? su[0] : { leadTeam_id : "",  user_id : "", user_name : "" };

            },
            getSourceAgents(search){
                this.form.source_agent.user_name = search;
                this.$send(this, 'leadTeamUsers', {
                    search: search
                }).then(r => {
                    this.leadTeamAgents = r.leadTeamUsers;
                }).catch(err => {
                    this.error = err.toString();

                })
            },

            saveLead(){

                this.error = "";

                if(!this.form.name) this.error = "Please enter a name";

                if(!this.error.length && !this.isLoading) {
                    this.isLoading = true;
                    var data = {
                        name: this.form.name,
                        source_user_id: this.form.source_agent.user_id,
                        locations: this.form.data_locations,
                        notes: this.form.notes

                    }

                    this.$send(this, 'leadCreate', data).then(r => {
                        this.isLoading = false;
                        if(r.lead_id){
                            this.$router.push('leads/' + r.lead_id);
                        }

                    }).catch(err => {
                        this.error = err.toString();
                    })
                }
            }
        },
        mounted(){
            this.$refs['name'].focus();
        },

        props: ['selected']
    }
</script>

<style scoped>
    a.toggle-link:active,
    a.toggle-link:hover,
    a.toggle-link{

        display: block;
        padding: 2px 4px;
        color: #0288d1;
        cursor:pointer;


    }

</style>



// WEBPACK FOOTER //
// AddLead.vue?3b51ade3